import IncomingPaymentMethod from '../models/IncomingPaymentMethod'

export const IncomingPaymentMethodMixin = {
  data() {
    return {
       incoming_payment_method: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new IncomingPaymentMethod({
          country_id: undefined,
          method: undefined,
          page_template: null,
          instructions: '',
          transaction_fee: 0,
          processing_time: '',
          description: '',
          is_default: true,
          is_public: true,
          is_fast: false,
      })
    }
  }
}
